module.exports = __webpack_public_path__ + "static/img/expand.1114efc0.svg";